module.exports = __webpack_public_path__ + "img/1.04313e04.jpg";